import moment from "moment-timezone";
import Vue from "vue";
export default {
    namespaced: true,
    state: {
        notification: false,
        items: {
            alarms: []
        },
    },
    mutations: {
        initAlarm(state, { alarmId, seprobanAlarmId, unitName, unit, created, totalImages, event }) {
            const intAlarmId = Number(alarmId);
            const existingAlarm = state.items.alarms.find(
                alarm => Number(alarm.id_alarm) === intAlarmId
            );

            if (existingAlarm) {
                if (seprobanAlarmId != null) {
                    existingAlarm.id_seproban_alarm = Number(seprobanAlarmId);
                }
                if (unitName) existingAlarm.unit_name = unitName;
                if (unit) existingAlarm.unit = unit;
                if (created) existingAlarm.created = created;
                if (totalImages != null) existingAlarm.total_images = totalImages;
                if (event) {
                    existingAlarm.downloaded_at = event.downloaded_at;
                    existingAlarm.first_snapshot_downloaded_at = event.first_snapshot_downloaded_at;
                    existingAlarm.last_snapshot_downloaded_at = event.last_snapshot_downloaded_at;
                    existingAlarm.sent_seproban_at = event.sent_seproban_at;
                    existingAlarm.first_snapshot_sent_at = event.first_snapshot_sent_at;
                    existingAlarm.last_snapshot_sent_at = event.last_snapshot_sent_at;
                }
            } else {
                state.items.alarms.push({
                    id_alarm: intAlarmId,
                    id_seproban_alarm: seprobanAlarmId != null
                        ? Number(seprobanAlarmId)
                        : null,
                    unit_name: unitName,
                    unit: unit || null,
                    created: created,
                    total_images: totalImages,
                    downloaded_at: event?.downloaded_at || null,
                    first_snapshot_downloaded_at: event?.first_snapshot_downloaded_at || null,
                    last_snapshot_downloaded_at: event?.last_snapshot_downloaded_at || null,
                    sent_seproban_at: event?.sent_seproban_at || null,
                    first_snapshot_sent_at: event?.first_snapshot_sent_at || null,
                    last_snapshot_sent_at: event?.last_snapshot_sent_at || null,
                    cameras: []
                });
            }
        },
        setFilteredCameras(state, { alarmId, cameras }) {
            const alarm = state.items.alarms.find(alarm => alarm.id_alarm === alarmId);
            if (!alarm) return;

            alarm.cameras = alarm.cameras || [];
            const camList = Array.isArray(cameras) ? cameras : [cameras];

            for (const cam of camList) {
                const existingCamera = alarm.cameras.find(
                    c => c.camera_proxy_id === cam.camera_proxy_id
                );
                if (existingCamera) {
                    Object.assign(existingCamera, cam);
                } else {
                    alarm.cameras.push(cam);
                }
            }
        },
        updateDownloadData(state, { alarmId, cameraId, imageUrl, progress, timestamp }) {
            const alarm = state.items.alarms.find(a => Number(a.id_alarm) === Number(alarmId));
            if (!alarm) return;

            const downloadedAt = Date.now();
            if (!alarm.first_snapshot_downloaded_at) {
                alarm.first_snapshot_downloaded_at = downloadedAt;
            }
            alarm.last_snapshot_downloaded_at = downloadedAt;
            alarm.downloaded_at = downloadedAt;

            const camera = alarm.cameras.find(
                c => Number(c.camera_proxy_id) === Number(cameraId)
            );
            if (!camera) return;

            camera.download_progress = Math.max(camera.download_progress || 0, progress);

            if (!camera.images) {
                Vue.set(camera, "images", []);
            }
            
            //const isValidImage = /\.(jpg|jpeg)$/i.test(imageUrl);
            if (!imageUrl) return;

            const existingImage = camera.images.find(img => img.url === imageUrl);
            if (existingImage) {
                if (!existingImage.downloaded_at) existingImage.downloaded_at = downloadedAt;
                if (!existingImage.timestamp) existingImage.timestamp = timestamp;
            } else {
                camera.images.push({
                    url: imageUrl,
                    timestamp: timestamp,
                    downloaded_at: downloadedAt,
                });
                Vue.set(
                    camera,
                    "downloaded_images",
                    Math.max(Number(camera.downloaded_images) + 1 || 1, camera.images.length)
                );
            }
        },
        updateUploadData(state, { alarmId, cameraId, imageUrl, progress, timestamp }) {
            const alarm = state.items.alarms.find(a => a.id_alarm === alarmId);
            if (!alarm) return;

            const sentAt = timestamp || Date.now();
            if (!alarm.first_snapshot_sent_at) alarm.first_snapshot_sent_at = sentAt;
            alarm.last_snapshot_sent_at = sentAt;

            const camera = alarm.cameras.find(c => c.camera_proxy_id === cameraId);
            if (!camera) return;

            //camera.upload_progress = progress
            camera.upload_progress = Math.max(camera.upload_progress || 0, progress);
            //alarm.cameras = [...alarm.cameras];

            if (!camera.sent_images) camera.sent_images = 0;
            const current = Math.ceil((alarm.total_images / alarm.cameras.length) * (progress / 100));
            camera.sent_images = Math.max(camera.sent_images, current);
            // if (progress >= 100) {
            //     camera.sent_images = alarm.total_images;
            // }

            if (!camera.images) {
                camera.images = [];
            }

            //const isValidImage = /\.(jpg|jpeg)$/i.test(imageUrl);
            if (!imageUrl) return;

            const existingImage = camera.images.find(img => img.url === imageUrl);
            if (existingImage) {
                existingImage.sent_at = sentAt;
            } else {
                camera.images.push({
                    url: imageUrl,
                    timestamp: Date.now(),
                    sent_at: sentAt,
                });
            }
        },
        setNotification(state, payload) {
            state.notification = payload;
        },
        removeAllCompletedAlarms(state) {
            state.items.alarms = state.items.alarms.filter(alarm => {
                return alarm.cameras.some(camera => camera.upload_progress !== 100);
            });

            if (state.items.alarms.length === 0) {
                state.notification = false;
            }
        }
    },
};
